<template>
    <div class="w-full">
        <tabs ref="tabs" class="w-full" @tabSelected="onTabSelected" :pre-selected-index="this.auction !== null ? 1 : 0">
            <tab :title="$t('pages.auctions.planning.tabs.overview')">
                <planning-overview
                    :auctions="auctions"
                    :active-auction="auction"
                    :raw-auctions="rawAuctions"
                    @go-to-upload="goToUpload"
                    @go-to-details="goToDetails"
                    @go-to-delete="goToDelete"
                    @reload-auctions="reloadAuctions()"
                />
            </tab>
            <tab :title="$t('pages.auctions.planning.tabs.details')" :enabled="!!auction">
                <planning-details
                    :auction="auction"
                    :auctions="auctionsData"
                    :raw-auction="rawAuction"
                    :product-details-link="productDetailsLink"
                    :show-delete-modal="showDeleteModal"
                    @go-to-upload="goToUpload()"
                    @go-to-details="goToDetails"
                    @go-to-delete="goToDelete()"
                    @auctionDataUpdated="reloadAuctionData()"
                />
            </tab>
            <tab :title="$t('pages.auctions.planning.tabs.upload')">
                <planning-upload/>
            </tab>
        </tabs>
    </div>
</template>

<script>
import Tab from '@/Shared/Tab';
import Tabs from '@/Shared/Tabs';
import Layout from '@/Shared/Layout';
import AuctionState from "@/mixins/AuctionState";
import PlanningOverview from "./PlanningOverview";
import PlanningDetails from "./PlanningDetails";
import PlanningUpload from "./PlanningUpload";

export default {
    mixins: [AuctionState],
    layout: Layout,
    components: {
        Tab,
        Tabs,
        PlanningOverview,
        PlanningDetails,
        PlanningUpload
    },
    props: {
        productDetailsLink: {
            type: String,
            default: null
        },
        auctions: Object,
        auction: {
            type: Object,
            default: null
        },
        rawAuctions: [],
        rawAuction: {
            type: Object,
            default: null
        },
        action: {
            type: String,
            default: null
        },
        userNames: [],
        tab: String
    },
    metaInfo() {
        return {
            title: this.$t('pages.auctions.planning.title')
        }
    },
    data() {
        return {}
    },
    mounted() {
        if (this.auction !== null) {
            this.activateDetails();
        } else {
            // if a tab is given go to the tab
            if(this.tab?.includes('2')) {
                this.$refs.tabs.selectTab(2);
            }
        }
    },
    computed: {
        showDeleteModal() {
            return this.action === "del";
        },
        auctionsData() {
            return (this.auctions && this.auctions.data) ? Object.values(this.auctions.data) : [];
        }
    },
    methods: {
        goToUpload() {
            this.$refs.tabs.selectTab(2);
        },
        goToDetails(auctionId, action = '') {
            this.$inertia.visit(
                route('auctions.planning.detail', { auction: auctionId, action: action }),
                {
                    only: ['auction', 'action', 'rawAuction']
                }
            );
        },
        goToDelete(auctionId) {
            this.goToDetails(auctionId, 'del');
        },
        activateDetails() {
            this.$refs.tabs.selectTab(1);
        },
        onTabSelected(index) {
            switch(index) {
                case 1:
                    const query = Object.assign({},  this.route().params);
                    query.auction = this.auction.id;
                    window.history.pushState({}, '', this.route('auctions.planning.detail', query));

                    break;
                case 0:
                    window.history.pushState({}, '', this.route('auctions.planning'));
                    this.reloadAuctions();
            }
        },
        reloadAuctionData() {
            return this.$inertia.reload({
                preserveScroll: true,
                preserveState: true,
                only: ['auction', 'rawAuction']
            });
        },
        reloadAuctions() {
            return this.$inertia.reload({
                preserveScroll: true,
                preserveState: true,
                only: ['auctions', 'rawAuctions']
            });
        }
    }};
</script>
